import React from 'react'
import { toast } from 'react-toastify'
import { useIntl } from 'react-intl'
import { useParams, useSearchParams } from 'react-router-dom'
import styled from '@emotion/styled'
import { Box, LinearProgress } from '@mui/material'
import { H3 } from '../../../layouts/TextStyles'
import { courseUserApiSlice } from '../../../features/course/courseUserSlice'
import Breadcrumb from '../../../components/Breadcrumb'
import CoursesTable from './components/StudentCoursesTable'
import AddStudentCourseDialog from './components/AddStudentCourseDialog'
import { ui } from '../../../utils/uiTokens'
import { capitalize } from '../../../utils/functions'
import StudentControlBlock from '../../curator/studentProgressPage/StudentControlBlock'

const StudentCoursesPage = () => {
    const { studentId } = useParams()
    const [searchParams] = useSearchParams('')
    const fullName: string = searchParams.get('fullName')
    const { formatMessage, locale } = useIntl()
    const { data: courses = [], isFetching: isFetchingCourses } =
        courseUserApiSlice.useGetCoursesOfUserQuery(Number(studentId))
    const [deleteStudentFromCourse, { isLoading: isDeleting }] =
        courseUserApiSlice.useDeleteStudentFromCourseMutation()

    const handleDelete = async (id: number) => {
        try {
            await deleteStudentFromCourse(id).unwrap()
            toast.success(formatMessage({ id: 'deletedSuccess' }))
        } catch (e) {}
    }

    return (
        <Wrapper>
            <Breadcrumb />

            <Content>
                <Header>
                    <Title>
                        <H3>{fullName}</H3>
                    </Title>

                    <AddStudentCourseDialog studentId={+studentId} />
                </Header>

                {(isFetchingCourses || isDeleting) && <LinearProgress />}

                <CoursesTable
                    studentId={+studentId}
                    courses={courses}
                    isFetchingCourses={isFetchingCourses}
                    onDelete={handleDelete}
                />

                {/* строгий режим и «шықты» по каждому курсу; права решает бэкенд */}
                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, mt: 3 }}>
                    {courses.map((c) => (
                        <StudentControlBlock
                            key={c.id}
                            userCourseEnrollId={c.id}
                            title={c[`title${capitalize(locale)}`]}
                        />
                    ))}
                </Box>
            </Content>
        </Wrapper>
    )
}

export default StudentCoursesPage

const Wrapper = styled.div`
    margin: 10px;
    border-radius: 16px;
`
const Title = styled.div`
    text-align: left;
    display: flex;
    align-items: center;
`

const Content = styled.div`
    background-color: ${ui.card};
    border-radius: 16px;
    padding: 20px;
    min-height: 80vh;
`

const Header = styled.header`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;

    margin-bottom: 20px;
`
